import { fetchWrapper, formatLocalStorageKey } from '../nav/utils';
import { useLocalStorage } from '@rehooks/local-storage';
import { Response, SearchMetadata } from './types';
import { useQuery } from 'react-query';
import { NAVIGATION_ENDPOINTS } from '../nav/constants/urls';

export const useSearchMetadata = () => {
  const [cachedMetadata, setCachedMetadata] = useLocalStorage<SearchMetadata>(
    formatLocalStorageKey('ZSearchMetadata'),
  );

  return useQuery(
    'GET_SEARCH_METADATA',
    () => {
      return fetchWrapper<Response<SearchMetadata>>(
        NAVIGATION_ENDPOINTS.SEARCH_METADATA,
      )
        .then((response) => (response.success ? response.data : []))
        .catch(() => []);
    },
    {
      initialData: () => {
        if (cachedMetadata) {
          return cachedMetadata;
        }
      },
      onSuccess: (data) => {
        if (data?.length) {
          setCachedMetadata(data);
        }
      },
    },
  );
};
